import { createI18n } from "vue-i18n";
import { es, en } from "vuetify/locale";
import esLocale from "@/locales/es.json";
import enLocale from "@/locales/en.json";
import { LS_LOCALE } from "@/constants/StorageKeys";

const savedLocale = typeof window !== "undefined" ? localStorage.getItem(LS_LOCALE) : null;
const defaultLocale = savedLocale || process.env.VUE_APP_I18N_LOCALE || "es";

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: "es",
  messages: {
    es: {
      $vuetify: {
        ...es,
        datePicker: {
          title: "Seleccionar fecha",
          header: "Entre la fecha"

        },
      },
      ...esLocale,
    },
    en: {
      $vuetify: {
        ...en,
        datePicker: {
          title: "Select date",
          header: "Enter date"
        },
      },
      ...esLocale,
      ...enLocale,
    },
  },
});

export default i18n;
